import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-warning-dialog',
  templateUrl: './warning-dialog.component.html',
  styleUrls: ['./warning-dialog.component.scss'],
})
export class WarningDialogComponent {
  @Input() show: boolean;
  @Input() header: string;
  @Input() description: string;
  @Input() cancelBtnText = 'Cancel';
  @Input() acceptBtnText = 'Accept';

  @Output() cancel: EventEmitter<void> = new EventEmitter();
  @Output() next: EventEmitter<void> = new EventEmitter();

  constructor() {
  }

}
